import React from "react";
import ProgressBar from "@ramonak/react-progress-bar";

export const MyProgressBar = ({ percent }) => {
  return (
    <div title={percent + "%"} style={{ position: "relative" }}>
      <ProgressBar
        completed={percent}
        animateOnRender
        height="12px"
        isLabelVisible={false}
        bgColor="var(--primary-color)"
        baseBgColor="var(--text-muted)"
        borderRadius="0px"
        transitionDuration="1.5s"
        transitionTimingFunction="ease-in-out"
      />
    </div>
  );
};
